module.exports = __webpack_public_path__ + "static/our-story-phone-view-973a0434d909e60640adff672113310a.png";